import React from 'react';
import { action, observable, makeAutoObservable } from 'mobx';
import api from 'src/api';
import { default as showError } from 'src/utils/error.jsx';
import { GroupName, TranslationsContentState } from '../../TranslationsContent.state';

export interface AddTableRowPropsType {
    language: string;
    groupName: GroupName;
    uniqueKeys: string[];
    onUpdate: (callback: () => void) => void;
    onCancel: (e: React.MouseEvent) => void;
    translationsContentState: TranslationsContentState;
}

export class AddTableRowState {
    public readonly props: AddTableRowPropsType;
    @observable saving: boolean = false;
    @observable key: string = '';
    @observable value: string = '';

    constructor(props: AddTableRowPropsType) {
        this.props = props;
        makeAutoObservable(this);
    }

    @action onSaveClick = (): void => {
        if (this.key.trim() === '') {
            showError('Translation key must not be empty');
        } else if (this.props.uniqueKeys.includes(this.key)) {
            showError(`Conflicting language translations for key: "${this.key}"`);
        } else {
            this.saving = true;

            const url = `/translations/${this.props.groupName}/${this.props.language}/${this.key}`;
            api.post(url, { value: this.value })
                .then(() => this.props.onUpdate(() => (this.saving = true)))
                .catch(() => {
                    showError('Unable to add translation property');
                    this.saving = false;
                })
                .finally(async () => {
                    await this.props.translationsContentState.refreshLanguages();
                });
        }
    };

    @action onKeyChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (this.saving) {
            event.preventDefault();
        }

        this.key = event.target.value;
    };

    @action onValueChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (this.saving) {
            event.preventDefault();
        }

        this.value = event.target.value;
    };
}
